<template>
  <el-card class="box-card form-screen mb-50">
     <el-row>
       <el-col :span="24">
         <div class="card-header" v-if="shop && shop.id">
           <span class="font-weight-700">{{ $t('shops.form.input_labels.id') }} {{ shop.id }}</span>
           <hr>
         </div>
         <p v-if="this.shop.id !== undifined" class="check-shop-edit">{{ $t('shops.edit_text') }}</p>
         <el-form :rules="rules" :model="form" ref="form" id="form" method="post" :action="urls.action">
           <el-form-item prop="company_id" :error="getErrorForField('company_id', errors)"  v-if="this.role !== this.$userRole.partner.company">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.company') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-select
               v-model="form.company_id"
               :placeholder="$t('shops.form.input_placeholder.company')"
               @blur="validateSelect('company_id')"
               @change="$refs['form'].clearValidate('company_id')"
             >
               <el-option v-for="item in companies" :key="item.id" :label="item.name" :value="item.id"></el-option>
             </el-select>
           </el-form-item>
           <el-form-item prop="name" :error="getErrorForField('name', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.name') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-input
               v-model="form.name"
               :placeholder="$t('shops.form.input_placeholder.name')"
               name="name"
               @blur="trim('name')"
               :disabled="disable"
             >
             </el-input>
           </el-form-item>
           <el-form-item prop="genre_id" :error="getErrorForField('genre_id', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.genre') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-select
               v-model="form.genre_id"
               :placeholder="$t('shops.form.input_placeholder.genre')"
               class="input-size-189"
               @blur="validateSelect('genre_id')"
               @change="$refs['form'].clearValidate('genre_id')"
             >
               <el-option v-for="item in genres" :key="item.id" :label="item.name" :value="item.id"></el-option>
             </el-select>
           </el-form-item>
           <el-form-item prop="seat_id" :error="getErrorForField('seat_id', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.seat') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-select
               v-model="form.seat_id"
               :placeholder="$t('shops.form.input_placeholder.seat')"
               class="input-size-189"
               @blur="validateSelect('seat_id')"
               @change="$refs['form'].clearValidate('seat_id')"
             >
               <el-option v-for="item in seats" :key="item.id" :label="item.name" :value="item.id"></el-option>
             </el-select>
           </el-form-item>
           <el-form-item prop="representative_name" :error="getErrorForField('representative_name', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.representative_name') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-input name="representative_name" v-model="form.representative_name" :placeholder="$t('shops.form.input_placeholder.representative_name')" @blur="trim('representative_name')"></el-input>
           </el-form-item>
           <el-form-item prop="zip_code" :error="getErrorForField('zip_code', errors)" class="input-size-305">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.zip_code') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-input
               name="zip_code"
               v-model="form.zip_code"
               :placeholder="$t('shops.form.input_placeholder.zip_code')"
               @input="handleZipcode"
               :disabled="disable"
             >
             </el-input>
          </el-form-item>
           <el-button class="btn-form mt-20" @click="getAddressByZipcode">{{ $t('shops.form.btn_search_by_zip_code' )}}</el-button>
           <el-form-item prop="prefecture_id" :error="getErrorForField('prefecture_id', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.prefectures') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-select
               v-model="form.prefecture_id"
               :placeholder="$t('shops.form.input_placeholder.prefectures')"
               class="input-size-189"
               @blur="validateSelect('prefecture_id')"
               @change="$refs['form'].clearValidate('prefecture_id')"
               :disabled="disable"
              >
               <el-option v-for="item in prefectures" :key="item.id" :label="item.name" :value="item.id"></el-option>
             </el-select>
           </el-form-item>
           <el-form-item prop="city" :error="getErrorForField('city', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.city') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-input
               name="city"
               v-model="form.city"
               :placeholder="$t('shops.form.input_placeholder.city')"
               @blur="trim('city')"
               :disabled="disable"
             >
             </el-input>
           </el-form-item>
           <el-form-item prop="address_number" :error="getErrorForField('address_number', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.address_number') }}</label>
             <el-input
               name="address_number"
               v-model="form.address_number"
               :placeholder="$t('shops.form.input_placeholder.address_number')"
               @blur="trim('address_number')"
               :disabled="disable"
             >
             </el-input>
           </el-form-item>
           <el-form-item prop="house" :error="getErrorForField('house', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.house') }}</label>
             <el-input
               name="house"
               v-model="form.house"
               :placeholder="$t('shops.form.input_placeholder.house')"
               @blur="trim('house')"
               :disabled="disable"
             >
             </el-input>
           </el-form-item>
           <el-form-item prop="tel" :error="getErrorForField('tel', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.tel') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-input name="tel" v-model="form.tel" :placeholder="$t('shops.form.input_placeholder.tel')" @blur="trim('tel')"></el-input>
           </el-form-item>
           <el-form-item prop="mail_address" :error="getErrorForField('mail_address', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.mail_address') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-input name="mail_address" v-model="form.mail_address" :placeholder="$t('shops.form.input_placeholder.mail_address')" @blur="trim('mail_address')"></el-input>
           </el-form-item>
           <el-form-item prop="homepage_url">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.homepage_url') }}</label>
             <el-input name="homepage_url" v-model="form.homepage_url" :placeholder="$t('shops.form.input_placeholder.homepage_url')" @blur="trim('homepage_url')"></el-input>
           </el-form-item>
           <el-form-item>
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.memo') }}</label>
             <el-input name="memo" v-model="form.memo" :placeholder="$t('shops.form.input_placeholder.memo')" @blur="trim('memo')"></el-input>
           </el-form-item>
           <el-form-item prop="description" :error="getErrorForField('description', errors)">
            <label slot="label" class="el-form-item__label white-space-pre-line">{{ $t('shops.form.input_labels.description') }}</label>
            <el-input name="description" v-model="form.description" :placeholder="$t('shops.form.input_placeholder.description')" type="textarea" @blur="trim('description')"></el-input>
          </el-form-item>
           <div class="group-input"><span>{{ $t('shops.form.account_info') }}</span></div>
           <note-login-id v-if="this.role !== this.$userRole.partner.company"></note-login-id>
           <el-form-item prop="login_id" :error="getErrorForField('login_id', errors)">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.login_id') }} <span class="text-required">{{ $t('required') }}</span> </label>
             <el-input name="login_id" v-model="form.login_id" :placeholder="$t('shops.form.input_placeholder.login_id')" @blur="trim('login_id')"></el-input>
           </el-form-item>
           <el-form-item prop="status">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.status') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-radio-group v-model="form.status" v-if="this.role !== this.$userRole.partner.company">
                 <el-radio label="1" name="status">{{ $t('status.active') }}</el-radio>
                 <el-radio label="0" name="status">{{ $t('status.inactive') }}</el-radio>
             </el-radio-group>
             <span v-if="this.role == this.$userRole.partner.company">{{ statusDefault }}</span>
           </el-form-item>
           <el-form-item prop="is_display" v-if="this.role !== this.$userRole.partner.company">
             <label slot="label" class="el-form-item__label">{{ $t('shops.form.input_labels.is_display') }} <span class="text-required">{{ $t('required') }}</span></label>
             <el-radio-group v-model="form.is_display">
                 <el-radio label="1" name="is_display">{{ $t('shops.show') }}</el-radio>
                 <el-radio label="0" name="is_display">{{ $t('shops.hide') }}</el-radio>
             </el-radio-group>
             <span v-if="this.role == this.$userRole.partner.company">{{ statusDefault }}</span>
           </el-form-item>
           <input type="hidden" name="_token" :value="csrf">
           <input type="hidden" name="genre_id" :value="form.genre_id">
           <input type="hidden" name="prefecture_id" :value="form.prefecture_id">
           <input type="hidden" name="company_id" :value="form.company_id">
           <input type="hidden" name="seat_id" :value="form.seat_id">
           <input type="hidden" name="id" :value="shop.id" v-if="shop && shop.id">
           <input type="hidden" name="handle_approve" :value="form.handleApprove">
           <el-form-item class="btn-container">
             <el-button type="primary" @click="submit('form')" class="btn btn-submit">{{ btn }}</el-button>
             <el-button @click="back" class="btn btn-back">{{ $t('back') }}</el-button>
           </el-form-item>
         </el-form>
       </el-col>
     </el-row>
   </el-card>
 </template>
 <script>
   import { getAddressByZipcode } from '../../api/zipcode'
   export default {
     props: {
       companies: { type: Array, required: false, default: [] },
       prefectures: { type: Array, required: true, default: [] },
       genres: { type: Array, required: true, default: [] },
       seats: { type: Array, required: true, default: [] },
       errors: { type: Object, required: false },
       input: { type: Object, required: false },
       shop: { type: Object, default: {} },
       urls: { type: Object, required: true, default: {} },
       btn: { type: String, required: true, default: '' },
       role: { type: Number, required: false },
       site: { type: Number, required: false },
     },
     data() {
       const checkRegexLoginId = (rule, value, callback) => {
         const regex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,255}$/);
         if (!regex.test(value)) {
           callback(new Error(this.$t('errors.login_id.format')));
         } else {
           callback();
         }
       }
       const validateNumber = (rule, value, callback) => {
         const regex = new RegExp(/^-?[\d.]+(?:e-?\d+)?$/);
         if (!regex.test(value)) {
           callback(new Error(this.$t('errors.numeric', [this.$t('shops.form.zip_code')])))
         } else {
           callback()
         }
       }
       const checkRegexTel = (rule, value, callback) => {
         const regex = new RegExp(/^([0-9\s\-]*)$/);
         if (!regex.test(value)) {
           callback(new Error(this.$t('errors.tel_format')));
         } else {
           callback();
         }
       }
       const checkEmpty = (rule, value, callback) => {
         if (!value || value.trim().length === 0) {
           callback(new Error('error'));
         } else {
           callback();
         }
       }
       const checkStatusShop = (rule, value, callback) => {
         if (value == 2) {
           callback(new Error('error'));
         } else {
           callback();
         }
       }
       return {
         form: {
             name: '',
             company_id: '',
             genre_id: '',
             seat_id: '',
             representative_name: '',
             zip_code: '',
             prefecture_id: '',
             city: '',
             address_number: '',
             house: '',
             tel: '',
             mail_address: '',
             homepage_url: '',
             description: '',
             memo: '',
             login_id: '',
             status: '1',
             is_display: '1',
             handleApprove: 0
         },
         rules: {
           name: [
             { validator: checkEmpty, message: this.$t('errors.required', [this.$t('shops.form.input_labels.name')]), trigger: 'blur' },
             { max: 255, message: this.$t('errors.max', [this.$t('shops.form.input_labels.name'), 255]), trigger: 'blur' },
           ],
           company_id: [
             { required: true, message: this.$t('errors.required', [this.$t('shops.form.input_labels.company')]), trigger: 'blur' },
           ],
           genre_id: [
             { required: true, message: this.$t('errors.required', [this.$t('shops.form.input_labels.genre')]), trigger: 'blur' },
           ],
           seat_id: [
             { required: true, message: this.$t('errors.required', [this.$t('shops.form.input_labels.seat')]), trigger: 'blur' },
           ],
           representative_name: [
             { validator: checkEmpty, message: this.$t('errors.required', [this.$t('shops.form.input_labels.representative_name')]), trigger: 'blur' },
             { max: 255, message: this.$t('errors.max', [this.$t('shops.form.input_labels.representative_name'), 255]), trigger: 'blur' },
           ],
           zip_code: [
             { validator: checkEmpty, message: this.$t('errors.required', [this.$t('shops.form.zip_code')]), trigger: 'blur' },
             { validator: validateNumber, trigger: 'blur' },
             { min: 7, max: 7, message: this.$t('errors.size.numeric', [this.$t('shops.form.zip_code'), 7]), trigger: 'blur' },
           ],
           prefecture_id: [
             { required: true, message: this.$t('errors.required', [this.$t('shops.form.input_labels.prefectures')]), trigger: 'blur' },
           ],
           city: [
             { validator: checkEmpty, message: this.$t('errors.required', [this.$t('shops.form.input_labels.city')]), trigger: 'blur' },
             { max: 255, message: this.$t('errors.max', [this.$t('shops.form.input_labels.city'), 255]), trigger: 'blur' },
           ],
           address_number: [
             { max: 255, message: this.$t('errors.max', [this.$t('shops.form.input_labels.address_number'), 255]), trigger: 'blur' },
           ],
           house: [
             { max: 100, message: this.$t('errors.max', [this.$t('shops.form.input_labels.house'), 100]), trigger: 'blur' },
           ],
           tel: [
             { validator: checkEmpty, message: this.$t('errors.required', [this.$t('shops.form.input_labels.tel')]), trigger: 'blur' },
             { max: 15, message: this.$t('errors.max', [this.$t('shops.form.input_labels.tel'), 15]), trigger: 'blur' },
             { validator: checkRegexTel, trigger: 'blur' },
           ],
           mail_address: [
             { validator: checkEmpty, message: this.$t('errors.required', [this.$t('shops.form.input_labels.mail_address')]), trigger: 'blur' },
             { max: 255, message: this.$t('errors.max', [this.$t('shops.form.input_labels.mail_address'), 255]), trigger: 'blur' },
             { type: "email", message: this.$t('errors.mail'), trigger: 'blur' }
           ],
           login_id: [
             { validator: checkEmpty, message: this.$t('errors.required', [this.$t('shops.form.login_id')]), trigger: 'blur' },
             { max: 255, message: this.$t('errors.max', [this.$t('shops.form.login_id'), 255]), trigger: 'blur' },
             { min: 8, message: this.$t('errors.min', [this.$t('shops.form.login_id'), 8]), trigger: 'blur' },
             { validator: checkRegexLoginId, trigger: 'blur' },
           ],
           homepage_url: [
             { max: 1000, message: this.$t('errors.max', [this.$t('shops.form.input_labels.homepage_url'), 1000]), trigger: 'blur' },
           ],
           status: [
            { validator: this.role !== this.$userRole.partner.company ? checkStatusShop : '', message: this.$t('errors.required', [this.$t('shops.form.input_labels.status')]), trigger: 'blur' },
           ],
           is_display: [
            { message: this.$t('errors.required', [this.$t('shops.form.input_labels.is_display')]), trigger: 'blur' },
           ]
         },
         csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
         statusDefault: this.$t('status.active'),
         disable: false
       }
     },
     methods: {
       submit(formName) {
         this.$refs[formName].validate((valid) => {
           if (valid) {
             document.querySelector(".el-container").classList.add("disabled");
             document.querySelector("#loader").style.display = "block";

             const form = document.getElementById("form");
             form.submit();
           } else {
             return false;
           }
         });
       },

       getAddressByZipcode() {
         getAddressByZipcode(this.form.zip_code)
         .then(response => response.json())
         .then(response => {
           if (response.status_code === 200) {
             this.form.prefecture_id = response.data.prefecture_id;
             this.form.address_number = response.data.address_number;
             this.form.city = response.data.city;
             this.$refs['form'].clearValidate(['prefecture_id', 'address_number', 'city', 'zip_code' ])
           }
         })
       },

       isErrorForField(field, errors) {
         return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
       },

       getErrorForField(field, errors) {
         return this.isErrorForField(field, errors) ? errors[field][0] : '';
       },

       back() {
         window.location.href = this.urls.back;
       },

       handleZipcode() {
         this.form.zip_code = this.form.zip_code.replace(/\D/g,'');
         if (this.form.zip_code.length > 7) {
           this.form.zip_code = this.form.zip_code.substr(0, 7);
         }
       },

       trim(field) {
         if (this.form[field]) {
           this.form[field] = this.form[field].trim();
         }
       },

       validateSelect(filed) {
         this.$refs['form'].validateField(filed)
       }
     },

     created() {
       const queryString = window.location.search;
       const urlParams = new URLSearchParams(queryString);

       const tempData = (Object.keys(this.input).length === 0) ? this.shop : this.input;
       this.form = Object.fromEntries(Object.entries(tempData).map(([key, value]) => [key, value]));
       this.form.status = (tempData.hasOwnProperty('status')) ? tempData.status.toString() : '1';
       this.form.is_display = (tempData.hasOwnProperty('is_display')) ? tempData.is_display.toString() : '1';
       this.form.prefecture_id = (tempData.prefecture_id) ? parseInt(tempData.prefecture_id) : '';
       this.form.company_id = (tempData.company_id) ? parseInt(tempData.company_id) : '';
       this.form.seat_id = (tempData.seat_id) ? parseInt(tempData.seat_id) : '';
       this.form.genre_id = (tempData.genre_id) ? parseInt(tempData.genre_id) : '';
       this.form.description = tempData.description ? tempData.description : '';

       if (urlParams.get('company_id') && !tempData.company_id) {
         this.form.company_id = parseInt(urlParams.get('company_id'));
       }
       if (this.form.status == this.$partnerStatus.pending) {
         this.form.handleApprove = 1;
       }

       if (this.role === this.$userRole.partner.company && this.shop.status_text) {
         this.statusDefault = this.shop.status_text;
       }
       if (this.site === this.$siteType.site_partner) {
         this.disable = true;
       }
    },
   }
 </script>
 <style lang="scss" scoped>
   .check-shop-edit {
     background: #DDD8D1 0% 0% no-repeat padding-box;
     font: normal normal normal 13px/normal Kozuka Gothic Pr6N;
     letter-spacing: 1.3px;
     color: #000000;
     padding: 0 16px;
     height: 30px;
     margin: 20px 0 10px;
     display: flex;
     align-items: center;
   }
   .group-input {
     margin-bottom: 30px;
   }
   .form-screen {
     .el-form {
       .note-login-id {
         margin-top: 0;
         padding-top: 40px;
         padding-bottom: 40px;
         padding-left: 30px;
       }
     }
   }
 </style>
 